import { Flex, useToast } from '@chakra-ui/react';
import { BsCalendarWeek, BsFillJournalBookmarkFill } from 'react-icons/bs';
import { PiStudentFill } from 'react-icons/pi';
import { IoSchoolOutline } from 'react-icons/io5';

import DashLayout from '../../components/DashLayout';
import { Loading } from '../../components/Loading';
import { GraficosDashboard } from '../../components/GraficosDashboard';
import { MuralInformativos } from '../../components/MuralInformativos';
import { PainelNovidades } from '../../components/Novidades/PainelNovidades';
import { StatCard } from '../../components/StatCard';
import { useEffect, useState } from 'react';
import { dashData } from '../../services/api';
import useAuth from '../../hooks/useAuth';

export const HomePage = () => {
	const [loading, setLoading] = useState<boolean>(true);
	const [aulasAgendadas, setAulasAgendadas] = useState<string>('');
	const [aulasConcluidas, setAulasConcluidas] = useState<string>('');
	const [alunos, setAlunos] = useState<string>('');
	const [professores, setProfessores] = useState<string>('');
	const [aulasProximosSeteDias, setAulasProximosSeteDias] = useState<string>('');

	const { user } = useAuth();
	const toast = useToast();

	useEffect(() => {
		dashData(`${user?.sub}`)
			.then((res) => {
				setAlunos(res.data.alunos);
				// A API devolve chaves diferentes por perfil: `professores` só vem para
				// o ADMIN, `aulasProximosSeteDias` só para o PROFESSOR.
				setProfessores(res.data.professores);
				setAulasProximosSeteDias(res.data.aulasProximosSeteDias);
				setAulasAgendadas(res.data.aulasAgendadas);
				setAulasConcluidas(res.data.aulasConcluidas);
				setLoading(false);
			})
			.catch((err) => {
				toast({
					title: `Não foi possível carregar os números do painel: ${err}`,
					status: 'error',
					isClosable: true
				});
			});
	}, [ user?.sub, toast ]);

	return (
		<DashLayout>
			{loading ? (
				<Loading label="Carregando dados..." />
			) : (
				<Flex flexDir="column" gap="20px" p={{ base: 4, md: 6 }} height="100%" overflowY="auto">
					{/* Os cartazes da escola abrem o painel: valem para quem dá aula
					    tanto quanto para quem assiste, e é o que muda com mais
					    frequência. Os números e os gráficos vêm abaixo. */}
					<MuralInformativos />
					<Flex gap="16px" flexWrap="wrap">
						{/* Quantos professores existem não diz nada para quem dá aula: o
						    professor vê no lugar as aulas que tem pela frente. */}
						{user?.userType === 'ADMIN' ? (
							<StatCard label="Professores" value={professores} icon={IoSchoolOutline} accent />
						) : (
							<StatCard label="Próximos 7 dias" value={aulasProximosSeteDias} icon={BsCalendarWeek} accent />
						)}
						<StatCard label="Alunos" value={alunos} icon={PiStudentFill} />
						<StatCard label="Aulas agendadas" value={aulasAgendadas} icon={BsFillJournalBookmarkFill} />
						<StatCard label="Aulas concluídas" value={aulasConcluidas} icon={BsFillJournalBookmarkFill} />
					</Flex>
					{/* Os gráficos são do admin: o professor não tem visão da escola
					    inteira, e a API responde 403 para ele nessa rota. */}
					{user?.userType === 'ADMIN' && <GraficosDashboard />}
					<PainelNovidades />
				</Flex>
			)}
		</DashLayout>
	);
};
